/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenseType } from '../../models/license-type';

export interface ApiMasterLicenseTypeGetAllGet$Params {
}

export function apiMasterLicenseTypeGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterLicenseTypeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterLicenseTypeGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LicenseType>>;
    })
  );
}

apiMasterLicenseTypeGetAllGet.PATH = '/api/Master/LicenseType/GetAll';
